module.exports = __webpack_public_path__ + "media/src/assets/img/portrait/small/avatar-s-4-6a665e7ccedce6cfb58f17aafae574ef.jpg";